export default __webpack_public_path__ + "static/media/login_bg_2.33ddeaac.jpg";